import { LoadIntercom } from '@crehana/layouts/components/load-intercom.universal';
import { App, type MyAppProps } from '@crehana/next';

// eslint-disable-next-line no-restricted-imports
import '@crehana/next/dist/main.css';
import '@crehana/tailwindcss/dist/crehana-tailwindcss.css';
// eslint-disable-next-line no-restricted-imports
import '@crehana/ui/dist/crehana-ui.min.css';
import 'nprogress/nprogress.css';
import '../styles/styles.css';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const CustomApp: React.FC<React.PropsWithChildren<MyAppProps>> = props => {
  return (
    <App
      {...props}
      pageProps={{ ...props.pageProps, disabledShoppingCart: true }}
      customRender={({ Component }) => {
        return (
          <>
            <Component err={props.err} {...props.pageProps} />
            <HanaFloatingChatLazy />
            <LoadIntercom />
          </>
        );
      }}
    />
  );
};

export default CustomApp;
